export const parseString = (str: string, replacement = false) => {
  let stop = false;
  let finalString = '';
  const stringArr: string[] = [];
  let tmpString = '';
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '{' && str[i + 1] === '{') {
      stop = true;
      stringArr.push(tmpString);
      tmpString = '';
    } else if (str[i] === '}' && str[i - 1] === '}') {
      stringArr.push(tmpString);
      tmpString = '';
      stop = false;
    } else {
      if (!stop) {
        finalString += str[i];
      }
      tmpString += str[i];
    }
  }
  stringArr.push(tmpString);
  if (replacement) {
    return stringArr;
  }
  return finalString;
};
